const KEY = 'wizard_ig';

export function saveWizardIgState(state) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(state));
  } catch (_) { /* storage lleno / bloqueado: no-op */ }
}

export function loadWizardIgState() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

export function clearWizardIgState() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) { /* no-op */ }
}
